/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
// import * as React from "react";
import React, { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import Button from "../../../components/Layout/Button";
import Modal from "../../../components/Modal/Modal";
import Typography from "../../../components/Typography/Typography";
import { SERVICES } from "../../../components/Layout/Services";
import { get } from "../../../components/Layout/ApiHandler/apihandler";

export default function DownloadReceiptModal({ open, onClose, uploadId }) {
  const [downloadCashDepositSlip, setDownloadCashDepositSlip] = useState(null);
  const [downloadChequeDDSameSlip, setDownloadChequeDDSameSlip] =
    useState(null);
  const [downloadChequeDDDifferentSlip, setDownloadChequeDDDifferentSlip] =
    useState(null);

  const getBankData = async () => {
    try {
      const url = `${SERVICES.OFFLINE_BANK_DEPOSIT}/${uploadId}/bankDepositReceipt`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const downloadReceiptData = data?.data;
        setDownloadCashDepositSlip(downloadReceiptData?.depositS3Url);
        setDownloadChequeDDSameSlip(
          // downloadReceiptData?.diffBankChequeDepositS3Url,
          downloadReceiptData?.sameBankChequeDepositS3Url,
        );
        setDownloadChequeDDDifferentSlip(
          // downloadReceiptData?.sameBankChequeDepositS3Url,
          downloadReceiptData?.diffBankChequeDepositS3Url,
        );
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const handleDownloadCashDepositSlip = () => {
    if (downloadCashDepositSlip) {
      window.open(downloadCashDepositSlip, "_blank");
    }
  };
  const handleDownloadChequeDDSameSlip = () => {
    if (downloadChequeDDSameSlip) {
      window.open(downloadChequeDDSameSlip, "_blank");
    }
  };
  const handleDownloadChequeDDDifferentSlip = () => {
    if (downloadChequeDDDifferentSlip) {
      window.open(downloadChequeDDDifferentSlip, "_blank");
    }
  };
  useEffect(() => {
    if (open && uploadId) {
      getBankData();
    }
  }, [
    open,
    uploadId,
    downloadCashDepositSlip,
    downloadChequeDDSameSlip,
    downloadChequeDDDifferentSlip,
  ]);
  return (
    <Box tabIndex="0">
      <Modal open={open} onClose={onClose}>
        <Typography
          style={{
            fontSize: "20px ",
            fontWeight: "500",
            paddingBottom: "20px",
          }}
        >
          Downlaod Bank Stamped Deposit Slips
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            width: "400px",
          }}
        >
          <Typography
            style={{
              fontSize: "15px ",
              fontWeight: "200",
            }}
          >
            DownloadCash Deposit Slip
          </Typography>
          <Button
            width="40%"
            onClick={handleDownloadCashDepositSlip}
            disabled={!downloadCashDepositSlip}
          >
            Download
          </Button>
          <Typography
            style={{
              fontSize: "15px ",
              fontWeight: "200",
            }}
          >
            Download Cheque/DD (Same Bank) Slip
          </Typography>
          <Button
            width="40%"
            onClick={handleDownloadChequeDDSameSlip}
            disabled={!downloadChequeDDSameSlip}
          >
            Download
          </Button>
          <Typography
            style={{
              fontSize: "15px ",
              fontWeight: "200",
            }}
          >
            Download Cheque/DD (Different Bank) Slip
          </Typography>
          <Button
            width="40%"
            onClick={handleDownloadChequeDDDifferentSlip}
            disabled={!downloadChequeDDDifferentSlip}
          >
            Download
          </Button>
        </Box>
      </Modal>
    </Box>
  );
}
